<template>
  <div class="first-login">
    <terms-form
      :display-terms="!termsAccepted"
      @terms-accepted="termsAccepted=true"
    />
    <transition name="fade">
      <div
        v-if="termsAccepted"
        class="first-login-verify"
      >
        <input-field
          v-model="email"
          :editable="false"
          :value="email"
        >
          Email
        </input-field>
        <password-field
          :value="password"
          field-type="password"
          @input="evtPasswordChange"
        >
          Password
        </password-field>
        <password-field
          :value="verifyPassword"
          field-type="password"
          @input="evtVerifyPasswordChange"
        >
          Verify Password
        </password-field>
        <standard-button @click="register">
          Login
        </standard-button>
      </div>
    </transition>
    <va-modal
      v-if="showError"
      v-model="showError"
      title="Registration Failed"
      close-button
    >
      <div>{{ errorMessage }}</div>
      <standard-button @click="backToLogin">Return to Login screen</standard-button>
    </va-modal>
  </div>
</template>

<script>
import StandardButton from "@/components/elements/StandardButton";
import InputField from "@/components/elements/InputField";
import PasswordField from "@/components/elements/PasswordField";
import TermsForm from "./TermsForm";
export default {
	name: "FirstLogin",
	components: {
		InputField,
		PasswordField,
		StandardButton,
		TermsForm
	},
	data() {
		return {
			email:null,
			code:null,
			termsAccepted: false,
			username: "",
			password: "",
			verifyPassword: "",
			showError: false,
			errorMessage: "XXX"
		}
	},
	mounted() {
		this.email = this.$route.params.email;
		this.code = this.$route.params.code;
	},
	methods: {
		register(){
			if(this.password === this.verifyPassword){
				this.$apiManager.post("first-login", {
					email: this.email,
					code:this.code,
					password: this.password
				}).then(
					(pack) => this.registrationComplete(pack),
					() => this.registrationFailed()
				);
			} else {
				this.errorMessage = "Password and password confirmation do not match.";
				this.showError = true;
			}
		},
		evtPasswordChange(newValue){
			if (typeof newValue === 'string') {
				this.password = newValue;
			}
		},
		evtVerifyPasswordChange(newValue){
			if (typeof newValue === 'string') {
				this.verifyPassword = newValue;
			}
		},
		registrationComplete(pack){
			if(pack.data && pack.data.success){
				this.$apiManager.token = pack.data.token;
				if(pack.data.adminUrl){
					this.$apiManager.adminUrl = pack.data.adminUrl;
				}
				this.$apiManager.get("user").then(
					(pack) => this.userDataSuccess(pack),
					() => this.dataFailure(),
				);
			} else {
				this.registrationFailed();
			}

		},
		userDataSuccess(pack){
			if(pack.data && pack.data.success){
				this.$dataDirectory.userData = pack.data;
				this.$router.push("/dashboard");
			} else {
				this.dataFailure();
			}
		},
		registrationFailed(){
			this.errorMessage = "The link you followed is no longer valid. Please return to the Login screen and click 'Forgot Password'.";
			this.showError = true;
		},
		dataFailure(){
			this.errorMessage = "There was an issue communicating with the server. Please try again later.";
			this.showError = true;
		},
		backToLogin(){
			this.$router.push("/login");
		},
	}
}
</script>
<style lang="scss" scoped>
.first-login{
	height: 100vh;
	&-verify{
		width: 500px;
		height: 300px;
		position: fixed;
		top:calc(50vh - 150px);
		left: calc(50vw - 250px);
		-webkit-box-shadow: 0px 0px 8px 2px rgba(46,46,46,0.65);
		box-shadow: 0px 0px 8px 2px rgba(46,46,46,0.65);
		border-radius: 15px;
		text-align: center;
		padding: 50px;

		@media screen and (max-width: 600px) {
			width: calc(100% - 50px);
			margin: 0 auto;
			position: sticky;
      height: unset;

      label {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
		}
	}
}
.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
	opacity: 0;
}
</style>